import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "56",
  height: "40",
  viewBox: "0 0 56 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "56",
      height: "40",
      rx: "8",
      fill: "#F3F1FF"
    }, null, -1),
    _createElementVNode("path", {
      d: "M9.992 29V12.2H13.208L20.36 24.056H18.656L25.688 12.2H28.88L28.928 29H25.28L25.256 17.792H25.928L20.312 27.224H18.56L12.824 17.792H13.64V29H9.992Z",
      fill: "#2B1072"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "42",
      cy: "12",
      r: "6",
      fill: "#2B1072"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "42",
      cy: "28",
      r: "6",
      fill: "#A45CFF"
    }, null, -1)
  ])))
}
export default { render: render }